import React, { FC } from 'react';
import { LobCode, Product, ProductWidget } from 'omni-package-react-core';
import Content from './Content';

export interface DefaultProductWidgetProps {
  product: Product;
}

const DefaultProductWidget: FC<DefaultProductWidgetProps> = ({ product }) => {
  const icon = product.iconCode?.toLowerCase() as LobCode;

  return (
    <ProductWidget
      lobCode={icon}
      productTypeTitle={product.description}
      productTypePath={product.browsingValue}
      isClickable={product.isClickable}
    >
      {
        !product.uniqueLinkText && <Content product={product} />
      }
    </ProductWidget>
  );
};
export default DefaultProductWidget;
